var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-expansion-panel', {
    ref: "panel",
    staticClass: "rounded-lg"
  }, [_c('v-sheet', {
    staticClass: "d-sm-none rounded-lg pa-2 pt-4"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "contain": "",
      "src": _vm.thumbnailSrc,
      "max-width": _vm.$vuetify.breakpoint.smAndDown ? 75 : 100,
      "max-height": _vm.$vuetify.breakpoint.smAndDown ? 75 : 100
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$store.dispatch('setImageModal', _vm.thumbnailSrc);
      }
    }
  })], 1), _c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [_c('v-row', {
    attrs: {
      "dense": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "0",
      "sm": "2",
      "align-self": "center"
    }
  }, [_c('v-img', {
    staticClass: "d-none d-sm-block pa-0",
    attrs: {
      "contain": "",
      "src": _vm.thumbnailSrc,
      "max-width": _vm.$vuetify.breakpoint.smAndDown ? 75 : 100,
      "max-height": _vm.$vuetify.breakpoint.smAndDown ? 75 : 100
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$store.dispatch('setImageModal', _vm.thumbnailSrc);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('v-row', {
    staticClass: "display-flex align-center justify-start",
    attrs: {
      "dense": ""
    }
  }, [_c('span', {
    staticClass: "font-weight-medium title primary--text"
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " ")])]), _c('v-row', {
    staticClass: "display-flex align-center justify-start",
    attrs: {
      "dense": ""
    }
  }, [_c('div', [_c('v-avatar', {
    staticClass: "mr-1",
    attrs: {
      "size": "10",
      "color": _vm.categoriesById[_vm.item.category].color
    }
  }), _c('p', {
    staticClass: "font-italic subheading text-no-wrap text-capitalize",
    staticStyle: {
      "display": "inline"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.categoryName)
    }
  })], 1)]), _c('v-row', {
    staticClass: "display-flex align-start justify-start my-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    staticClass: "text-xs-left"
  }, [_c('p', {
    staticClass: "caption body-1 pa-2",
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  })])], 1), _c('v-row', {
    staticClass: "my-2",
    attrs: {
      "dense": "",
      "align": "center",
      "justify": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.checkAvailability.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-calendar-search ")]), _vm._v("Check availability")], 1)], 1)], 1)], 1)], 1)], 1), _c('v-expansion-panel-content', [_c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "10",
      "offset": "2"
    }
  }, [_c('p', {
    staticClass: "title font-weight-bold primary--text"
  }, [_vm._v("DETAILS")])]), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('customFieldsList', {
    attrs: {
      "items": _vm.item.customFields
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }